import Experience from './Experience.js'
import AudioManager from './AudioManager.js'

export default class LoadingScreen
{
    constructor()
    {
        
        this.experience = new Experience()
        this.resources = this.experience.resources
        this.audioManager = this.experience.audioManager
        this.loadingScreen = document.getElementById('loading-screen')
        this.visualBarFill = document.getElementById('visual-bar-fill')

        this.audioChunkContainer = document.getElementById('audio-chunk-container')
        this.audioChunkTemplate = document.getElementById('audio-chunk-template')
        
        this.visualsFullyLoaded = false
        this.audioFullyLoaded = false

        for(let i = 0; i < this.audioManager.totalSounds; i++)
        {
            this.addAudioChunk()
        }

        // Visual Loader
        this.resources.on('fileLoaded', (progress) => 
        {

            this.visualBarFill.style.height = `${progress}%`
            
            if(progress === 100)
            {
                this.visualsFullyLoaded = true
            }

            this.checkIfFullyLoaded()
        })

        this.audioManager.on('soundLoaded', (progressCount) => 
        {
            const audioChunks = Array.from(this.audioChunkContainer.children)
            
            const index = this.audioManager.totalSounds - (progressCount)
            audioChunks[index].classList.add('loaded')
            
            if(progressCount === this.audioManager.totalSounds)
            {
                this.audioFullyLoaded = true
            }

            this.checkIfFullyLoaded()
        })

        

    }

    addAudioChunk()
    {
        const audioChunk = this.audioChunkTemplate.content.cloneNode(true)
        this.audioChunkContainer.appendChild(audioChunk)
    }

    checkIfFullyLoaded()
    {
        if(this.visualsFullyLoaded && this.audioFullyLoaded)
        {
            this.loadingScreen.style.display = 'none'
        }
    }
}